<template>
  <div class="container">
    <div class="list-container">
      <div class="car-pic">
        <el-form
            :model="dataList"
            :rules="rules"
            label-width="auto"
            style="max-width: 100%"
            :disabled="isDisabledEdit"
            ref="dataFormRef">

          <div class="header">
            <div class="title">车辆信息</div>
          </div>
          <table align="center" cellspacing="0">
            <tr>
              <td width="100px" style="background: #DAE3F5;color: black">车牌号</td>
              <td width="180px">
                <el-form-item label="" prop="licenseplate">
                  <el-input
                      clearable
                      v-model="dataList.licenseplate"
                  ></el-input>
                </el-form-item>
              </td>
              <td width="100px" style="background: #DAE3F5;color: black">出险时间</td>
              <td width="180px">
                <el-form-item label="" prop="dangertime">
                  <el-date-picker
                      clearable
                      v-model="dataList.dangertime"
                      type="date"
                      style="width: 180px"
                      format="YYYY/MM/DD"
                      value-format="YYYY-MM-DD"
                  />
                </el-form-item>
              </td>
            </tr>


            <tr>
              <td style="background: #DAE3F5;color: red">初登日期</td>
              <td>
                <el-form-item
                    label=""
                    prop="dateofregistration"
                >
                  <el-date-picker
                      clearable
                      v-model="dataList.dateofregistration"
                      type="date"
                      style="width: 180px"
                      format="YYYY/MM/DD"
                      value-format="YYYY-MM-DD"
                  />
                </el-form-item>
              </td>
              <td style="background: #DAE3F5;color: black">发动机号</td>
              <td>
                <el-form-item label="" prop="enginenumber">
                  <el-input
                      clearable
                      v-model="dataList.enginenumber"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>


            <tr>
              <td style="background: #DAE3F5;color: red">使用性质</td>
              <td>

                <el-form-item label="" class="other" prop="useproperty">
                  <el-input clearable v-model="dataList.useproperty"></el-input>
                </el-form-item>

              </td>
              <td style="background: #DAE3F5;color: black">车辆所属人</td>
              <td>
                <el-form-item label="" class="other" prop="ownernature">
                  <el-input clearable v-model="dataList.ownernature"></el-input>
                </el-form-item>
              </td>
            </tr>

            <!--              <tr>
                            <td style="background: #DAE3F5;color: black">品牌</td>
                            <td>
                              <el-form-item label="" prop="vehiclemodel">
                                <el-input
                                    clearable
                                    v-model="dataList.vehiclemodel"
                                ></el-input>
                              </el-form-item>

                            </td>
                            <td style="background: #DAE3F5;color: black">排量</td>
                            <td>

                              <el-form-item label="" prop="outputvolume">
                                <el-input
                                    clearable
                                    v-model="dataList.outputvolume"
                                ></el-input>
                              </el-form-item>
                            </td>
                          </tr>-->


            <tr>
              <td style="background: #DAE3F5;color: black">车型</td>
              <td colspan="3">
                <el-form-item label="" prop="models">
                  <el-input clearable v-model="dataList.models"></el-input>
                </el-form-item>
              </td>

            </tr>

            <tr>
              <td style="background: #DAE3F5;color: black">车架号</td>
              <td colspan="3">
                <el-form-item
                    label=""
                    class="form-item-1"
                    prop="vehicleidentificationnumber"
                >
                  <el-input
                      clearable
                      v-model="dataList.vehicleidentificationnumber"
                  ></el-input>
                </el-form-item>


              </td>

            </tr>

          </table>

          <el-divider/>

          <table align="center" cellspacing="0">
            <tr>
              <td width="100px" style="background: #DAE3F5;color: black">事故类型</td>
              <td width="180px">
                <el-form-item label="" prop="vehicledamagecause">
                  <el-select
                      v-model="dataList.vehicledamagecause"
                      clearable

                      placeholder=" "
                  >
                    <el-option
                        :label="item.label"
                        :value="item.label"
                        v-for="item in HiddenUsedCarAccident"
                        :key="item.value"
                    />
                  </el-select>
                </el-form-item>
              </td>
              <td width="100px" style="background: #DAE3F5;color: black">变速箱类型</td>
              <td width="180px">
                <el-form-item
                    label=""
                    prop="gearboxtype"
                >
                  <el-input clearable v-model="dataList.gearboxtype"></el-input>
                </el-form-item>
              </td>
            </tr>


            <tr>
              <td style="background: #DAE3F5;color: black">车架号损坏</td>
              <td>
                <el-form-item label="" prop="framenumberisdamaged">
                  <el-select
                      clearable

                      v-model="dataList.framenumberisdamaged"
                      placeholder=" "
                  >
                    <el-option label="不详" value="2"></el-option>
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </td>
              <td style="background: #DAE3F5;color: black">变速箱损坏</td>
              <td>
                <el-form-item label="" prop="isTransmissionDamaged">
                  <el-select
                      clearable

                      v-model="dataList.isTransmissionDamaged"
                      placeholder=" "
                  >
                    <el-option label="不详" :value="3"></el-option>
                    <el-option label="是" :value="2"></el-option>
                    <el-option label="否" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td style="background: #DAE3F5;color: black">发动机损坏</td>
              <td>
                <el-form-item label="" prop="isEngineDamaged">
                  <el-select
                      clearable

                      v-model="dataList.isEngineDamaged"
                      placeholder=" "
                  >
                    <el-option label="不详" :value="3"></el-option>
                    <el-option label="是" :value="2"></el-option>
                    <el-option label="否" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </td>
              <td style="background: #DAE3F5;color: black"></td>
              <td>

              </td>
            </tr>

          </table>
          <el-divider/>

          <table align="center" cellspacing="0">
            <tr>
              <td width="100px" style="background: #DAE3F5;color: black">是否二手车</td>
              <td width="180px">
                <el-form-item label="" prop="whetherusedcar">
                  <el-select
                      clearable

                      v-model="dataList.whetherusedcar"
                      placeholder=" "
                  >
                    <el-option label="不详" :value="3"></el-option>
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="2"></el-option>
                  </el-select>
                </el-form-item>
              </td>
              <td width="100px" style="background: #DAE3F5;color: black">二次事故</td>
              <td width="180px">
                <el-form-item label="" class="other" prop="ifaccident">
                  <el-input clearable v-model="dataList.ifaccident"></el-input>
                </el-form-item>
              </td>
            </tr>


            <tr>
              <td style="background: #DAE3F5;color: black">是否拆解</td>
              <td>
                <el-form-item
                    label=""
                    class="other"
                    prop="isDisassembly"
                >
                  <el-select
                      clearable
                      v-model="dataList.isDisassembly"
                      placeholder=" "
                  >
                    <el-option label="不详" :value="3"></el-option>
                    <el-option label="是" :value="2"></el-option>
                    <el-option label="否" :value="1"></el-option>
                  </el-select>
                </el-form-item>
              </td>
              <td style="background: #DAE3F5;color: black">是否贷款</td>
              <td>
                <el-form-item
                    label=""
                    class="other"
                    prop="isLoan"
                >
                  <el-select
                      clearable
                      v-model="dataList.isLoan"
                      placeholder=" "
                  >
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td style="background: #DAE3F5;color: red">是否二询</td>
              <td>
                <el-form-item
                    label=""
                    class="other"
                    prop="isSecondPrice"
                >
                  <el-select
                      clearable
                      v-model="dataList.isSecondPrice"
                      placeholder=" "
                  >
                    <el-option label="是" :value="1"></el-option>
                    <el-option label="否" :value="0"></el-option>
                  </el-select>
                </el-form-item>
              </td>
              <td style="background: #DAE3F5;color: black">二次报价原因</td>
              <td>
                <el-form-item label="" class="other" prop="twoquotationreason">
                  <el-input clearable v-model="dataList.twoquotationreason"></el-input>
                </el-form-item>
              </td>
            </tr>
          </table>
<!--          <div class="header">
            <div class="title">保险信息</div>
          </div>-->

<!--
          <table align="center" cellspacing="0">
            <tr>
              <td width="100px" style="background: #DAE3F5;color: black">保险公司</td>
              <td width="180px">
                <el-form-item
                    v-if="asilderText != '二手车' && dataList.companyType"
                    prop="companyType">
                  <el-input
                      :value="findOfferConfigLabel(dataList?.companyType)"
                      @input="updateCompanyType"
                      clearable
                  >
                  </el-input>
                </el-form-item>
                <el-form-item v-else prop="ershouCompany">
                  <el-input v-model="dataList.ershouCompany" clearable>
                  </el-input>
                </el-form-item>
              </td>
              <td width="100px" style="background: #DAE3F5;color: black">中标商编码</td>
              <td width="180px">
                <el-form-item prop="winningCompanyCode">
                  <el-input
                      clearable
                      v-model="dataList.winningCompanyCode"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>


            <tr>
              <td style="background: #DAE3F5;color: black">报案号</td>
              <td>
                <el-form-item label="" prop="claimNumber">
                  <el-input clearable v-model="dataList.claimNumber"></el-input>
                </el-form-item>
              </td>
              <td style="background: #DAE3F5;color: black">询价号</td>
              <td>
                <el-form-item label="" prop="vehiclenumber">
                  <el-input
                      clearable
                      v-model="dataList.vehiclenumber"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>


            <tr>
              <td style="background: #DAE3F5;color: black">查勘姓名</td>
              <td>
                <el-form-item label="" prop="lossofstaffname">
                  <el-input
                      clearable
                      v-model="dataList.lossofstaffname"
                  ></el-input>
                </el-form-item>
              </td>
              <td style="background: #DAE3F5;color: black">查勘电话</td>
              <td>
                <el-form-item label="" prop="lossofstaffphone">
                  <el-input
                      clearable
                      v-model="dataList.lossofstaffphone"
                      maxlength="11"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td style="background: #DAE3F5;color: black">车停放地</td>
              <td colspan="3">
                <el-form-item
                    label=""
                    prop="vehicletemporary"
                >
                  <el-input
                      clearable
                      v-model="dataList.vehicletemporary"
                  ></el-input>
                </el-form-item>
              </td>

            </tr>

            <tr>
              <td style="background: #DAE3F5;color: black">出险经过</td>
              <td colspan="3">
                <el-form-item
                    label=""
                    prop="cxjg"
                >
                  <el-input
                      clearable
                      v-model="dataList.cxjg"
                  ></el-input>
                </el-form-item>
              </td>

            </tr>

          </table>

          <el-divider/>-->

          <el-divider/>
          <table align="center" cellspacing="0">
            <tr>
              <td width="100px" style="background: #DAE3F5;color: black">保险金额</td>
              <td width="180px">
                <el-form-item label="" prop="insuranceamount">
                  <el-input
                      clearable
                      v-model="dataList.insuranceamount"
                  ></el-input>
                </el-form-item>
              </td>
              <td width="100px" style="background: #DAE3F5;color: black">实际价值</td>
              <td width="180px">
                <el-form-item label="" prop="practicalvalue">
                  <el-input
                      clearable
                      v-model="dataList.practicalvalue"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>


            <tr>
              <td style="background: #DAE3F5;color: black">预估损失</td>
              <td colspan="3">
                <el-form-item label="" prop="amountofestimatedloss">
                  <el-input
                      clearable
                      v-model="dataList.amountofestimatedloss"
                  ></el-input>
                </el-form-item>
              </td>

            </tr>

            <tr>
              <td width="100px" style="background: #DAE3F5;color: black">询价开始时间</td>
              <td>
                <el-form-item label="" prop="auctionstarttime">
                  <!-- 年月日时分秒 -->
                  <el-date-picker
                      v-model="dataList.auctionstarttime"
                      type="datetime"
                      style="width: 180px"
                      format="YYYY/MM/DD HH:mm:ss"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      clearable
                  />
                </el-form-item>
              </td>
              <td width="100px" style="background: #DAE3F5;color: black">询价截止时间</td>
              <td>
                <el-form-item label="" prop="auctionendtime">
                  <el-date-picker
                      clearable
                      v-model="dataList.auctionendtime"
                      type="datetime"
                      style="width: 180px"
                      format="YYYY/MM/DD HH:mm:ss"
                      value-format="YYYY-MM-DD HH:mm:ss"
                  />
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td style="background: #DAE3F5;color: black">车停放地</td>
              <td colspan="3">
                <el-form-item
                    label=""
                    prop="vehicletemporary"
                >
                  <el-input
                      clearable
                      v-model="dataList.vehicletemporary"
                  ></el-input>
                </el-form-item>
              </td>

            </tr>

            <tr>
              <td style="background: #DAE3F5;color: black">出险经过</td>
              <td colspan="3">
                <el-form-item
                    label=""
                    prop="cxjg"
                >
                  <el-input
                      clearable
                      v-model="dataList.cxjg"
                  ></el-input>
                </el-form-item>
              </td>

            </tr>

          </table>

          <el-divider/>

          <table align="center" cellspacing="0">
            <tr>
              <td width="100px" style="background: #DAE3F5;color: red">拆解费</td>
              <td width="180px">
                <el-form-item label="" class="other" prop="isSecondPrice">
                  <el-input
                      v-model="dataList.dismountCost"
                      placeholder=" "
                  ></el-input>
                </el-form-item>
              </td>

              <td width="100px" style="background: #DAE3F5;color: red">拖车费</td>
              <td width="180px">
                <el-form-item
                    label=""
                    prop="tuocf"
                >
                  <el-input
                      clearable
                      v-model="dataList.tuocf"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>


            <tr>
              <td style="background: #DAE3F5;color: red">停车费</td>
              <td>
                <el-form-item
                    label=""
                    prop="tingcf"
                >
                  <el-input
                      clearable
                      v-model="dataList.tingcf"
                  ></el-input>
                </el-form-item>
              </td>
              <td style="background: #DAE3F5;color: red">其他费用</td>
              <td>
                <el-form-item
                    label=""
                    prop="otherexpenses"
                >
                  <el-input
                      clearable
                      v-model="dataList.otherexpenses"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
            <tr>
              <td style="background: #DAE3F5;color: red">溢价率</td>
              <td>
                <el-form-item
                    label=""
                    prop="yjl"
                >
                  <el-input
                      clearable
                      v-model="dataList.yjl"
                  ></el-input>
                </el-form-item>
              </td>
              <td style="background: #DAE3F5;color: black"></td>
              <td>

              </td>
            </tr>


          </table>
<!--          <el-divider/>

          <table align="center" cellspacing="0">
            <tr>
              <td width="100" style="background: #DAE3F5;color: black">备注</td>
              <td width="463" colspan="3">
                <el-form-item label="">
                  <el-input
                      clearable
                      v-model="dataList.accidentdescription"
                      type="textarea"
                      rows="6"
                  ></el-input>
                </el-form-item>
              </td>
            </tr>
          </table>-->

          <el-divider/>




        </el-form>
      </div>
      <el-divider/>
      <!-- 车辆照片 -->
      <div class="car-pic">
        <div class="header">
          <span class="title">车辆照片</span>
          <el-button
              type="primary"
              class="btn-pic"
              v-if="dataList?.imgUrls?.length >= 1 && !isDisabledEdit"
              @click="clearImage"
          >一键清除图片
          </el-button
          >
        </div>
        <div class="pic">
          <UploadImages
              :mode="2"
              :limit="20"
              v-model="dataList.imgUrls"
              :isShowImage="isDisabledEdit"
          ></UploadImages>
        </div>
      </div>

      <el-divider/>

      <!-- 车300数据仅供参考 -->
      <div class="car-pic">
        <div class="header">
          <span class="title">车300数据仅供参考</span>
        </div>
        <el-row style="margin-top: 10px">
          <el-col :span="24">
            <div>
              <table align="center" cellspacing="0">
                <tr style="height: 50px">
                  <td width="180px" style="background: #DAE3F5;color: black">车型</td>
                  <td width="180px" style="background: #DAE3F5;color: black">户籍地</td>
                  <td width="180px" style="background: #DAE3F5;color: black">预估里程</td>
                  <td width="180px" style="background: #DAE3F5;color: black">新车指导价</td>

                </tr>
                <tr style="height: 50px">
                  <td><span>{{ info300 && info300.model_name ? info300.model_name : "-" }}</span></td>
                  <td><span>{{ info300 && info300.city_name ? info300.city_name : "-" }}</span></td>
                  <td><span>{{
                      info300 && info300.eval_result.mile_age ? info300.eval_result.mile_age + "万" : "-"
                    }}</span>
                  </td>
                  <td><span>{{ info300 && info300.model_price ? info300.model_price + "万" : "-" }}</span></td>
                </tr>
              </table>

            </div>
          </el-col>
        </el-row>
        <el-row style="margin-top: 20px">
          <el-col :span="24">
            <div>
              <div style="width: 100%;text-align: center">
                <el-radio-group style="margin-bottom: 30px" v-model="radio1"  @change="RadioChange" fill="#7f8daf"
                                text-color="#fff">
                  <el-radio-button value="normal">车况一版</el-radio-button>
                  <el-radio-button value="good">车况良好</el-radio-button>
                  <el-radio-button value="excellent">车况优秀</el-radio-button>
                </el-radio-group>
              </div>

              <div class="timelineBox-wrap">
                <div class="timelineBox" id="box">
                  <div class="timeline-up">
                    <div
                        :class="['timePoint',{'special':point.index == -1}]"
                        v-for="(point,index) in showData"
                        :key="index">
                      <ul class="list" v-if="(index+1)%2 == 0 && point.list && point.list.length">
                        <li
                            class="listItem"
                            :style="{'width':listWidth + 'px'}"
                            v-for="(item,idx) in point.list"
                            :key="idx">
                          {{ item }}
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="timeline">
                    <div
                        class="timePoint"
                        :class="{'special': point.index == 1}"
                        v-for="(point,index) in showData"
                        :key="index">
                      <div class="point"></div>
                      <span class="yearlabel"
                            style="width: 60px">{{ point.price == null ? "" : point.price + "w" }}</span>
                    </div>
                  </div>
                  <div class="timeline-down">
                    <div
                        class="timePoint"
                        :class="{'special': point.index == 1}"
                        v-for="(point,index) in showData"
                        :key="index">
                      <ul class="list" v-if="(index+1)%2 != 0 && point.list && point.list.length">
                        <li
                            class="listItem"
                            :style="{'width':listWidth + 'px'}"
                            v-for="(item,idx) in point.list"
                            :key="idx">
                          {{ item }}
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>

    </div>
  </div>
</template>
<script setup>
import {HiddenUsedCarAccident} from "@/data";
import {CarDetailRules} from "./modules/rules.js";
import {ref, watch, computed, inject, onMounted} from "vue";
import {findOfferConfigLabel} from "@/views/Quotation/model/offerConfig.js";
import UploadImages from "@/components/upload-images/index.vue";
import {get300Info} from "@/api/Quotation";

const props = defineProps({
  detailsData: {
    type: Object,
    default: () => {
    },
  },
  // 是否可以编辑
  isDisabledEdit: {
    type: Boolean,
    default: false,
  },
});
const mapData = new Map; // 创建响应式 Map
const radio1 = ref('top')
const info300 = ref(null)
const showData = ref([
  {
    "sYear": 0,
    "list": [
      "车商最低收车价"
    ],
    "index": -1
  },


]);

const RadioChange = (val) => {
  showData.value = mapData.get(val);
}

const handleGet300Info = async () => {
  let res = await get300Info({
    carId: props.detailsData.id,
  });
  console.log("res", res);
  if (res.entity) {
    info300.value = res.entity;
    const keys = Object.keys(res.entity.map);
    keys.forEach(key => {
      mapData.set(key, res.entity.map[key])
    });


    radio1.value = "normal"
    showData.value = mapData.get(radio1.value);
  }

}
const asilderText = inject("asilderText");
const emit = defineEmits(["update:detailsData"]);

const rules = ref(CarDetailRules);
const dataList = computed({
  get() {
    return props.detailsData;
  },
  set(newVal) {
    emit("update:detailsData", newVal);
  },
});
const clearImage = () => {
  emit("update:detailsData", {
    ...dataList.value,
    imgUrls: [],
  });
};
const updateCompanyType = (value) => {
  emit("update:detailsData", {
    ...dataList.value,
    companyType: value,
  });
};
const dataFormRef = ref(null);

// 校验表单
const validateForm = () => {
  return new Promise((resolve, reject) => {
    dataFormRef.value.validate((valid, ValidateFieldsError) => {
      if (valid) {
        resolve(dataList.value);
      } else {
        Object.keys(ValidateFieldsError).forEach((key) => {
          if (ValidateFieldsError[key]?.length) {
            const field = ValidateFieldsError[key][0].field;
            dataFormRef.value.scrollToField(field);
          }
        });
        reject(valid);
      }
    });
  });
};

// 清除校验表单
const clearValidateForm = () => {
  dataFormRef.value.clearValidate();
};

// 监听detailsData
watch(
    () => props.detailsData,
    (newVal) => {
      console.log("监听detailsData", newVal);
      handleGet300Info()
      emit("update:detailsData", newVal);
    },
    {
      deep: true,
      immediate: true,
    }
);

// 向外暴露
defineExpose({
  dataList,
  validateForm,
  clearValidateForm,
});
</script>
<style lang="scss" scoped>
.content {
  display: flex;
  box-sizing: border-box;

  .row {
    flex: 1;
    padding: 0 20px;
    box-sizing: border-box;

    .header {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 20px;
      width: 100%;

      .title {
        width: 200px;
        background-color: #a3a3e0;
        color: #000;
        font-size: 18px;
        text-align: center;
        height: 38px;
        line-height: 38px;
        border-radius: 8px;
      }
    }

    p {
      width: 100%;
      border: 1px solid #333;
      margin: 0 10px 0 0;
      padding-left: 12px;
      border-radius: 4px;
    }

    .form-container {
      display: flex;

      .box {
        width: 100%;
      }
    }

    /* .other {
       color: #f56c6c !important;
       font-weight: bold;

       :deep(.el-input__wrapper) {
         box-shadow: 0 0 0 1px #f56c6c inset !important;
       }

       :deep(.el-input__inner) {
         border-color: #f56c6c !important;
         color: #f56c6c !important;
       }

       :deep(.el-form-item__label) {
         color: #f56c6c !important;
       }
     }*/

    &:nth-child(2) {
      border-left: 1px solid #ccc;
      border-right: 1px solid #ccc;

      .form-container {
        display: flex;

        .box {
          width: 50%;
        }
      }
    }
  }
}

.car-pic {
  margin-top: 10px;

  .header {
    position: relative;
    padding-bottom: 10px;

    .title {
      color: #000;
      font-size: 20px;
      font-weight: 600;
      text-align: left;
      height: 30px;
      line-height: 30px;
      padding-right: 80px;
      padding-bottom: 10px;
    }

    .btn-pic {
      position: absolute;
      right: 100px;
    }
  }
}

table {
  border-right: 1px solid #000000;
  border-bottom: 1px solid #000000;
  text-align: center;
}

table th {
  border-left: 1px solid #000000;
  border-top: 1px solid #000000;
}

table td {
  font-size: 14px;
  font-weight: bold;
  color: #1d1e1f;
  border-left: 1px solid #000000;
  border-top: 1px solid #000000;
  /* padding: 10px;*/

  /* 移除输入框边框 */
  ::v-deep(.el-input__wrapper) {
    border: none !important;
    box-shadow: none !important;
  }

  /* 移除聚焦时的蓝框 */
  ::v-deep(.is-focus .el-input__wrapper) {
    box-shadow: none !important;
  }

  /* Vue 3 推荐使用 ::v-deep */
  ::v-deep( .el-input__inner) {
    border: none !important; /* 移除边框 */
    outline: none !important; /* 移除聚焦时的外框 */
    box-shadow: none !important;
  }

  /* 移除输入框边框 */
  ::v-deep( .el-input__inner) {
    border: none !important;
    outline: none !important;
  }

  /* 移除下拉面板的阴影和边框 */
  ::v-deep( .el-picker-panel) {
    box-shadow: none !important;
    border: none !important;
  }

  ::v-deep(.el-select__wrapper) {
    box-shadow: none !important;
  }

}

.el-form-item {
  display: flex;
  --font-size: 14px;
  margin-bottom: 0px;
}

body {
  background-color: #21222e;
}

.timelineBox-wrap {
  width: 80%;
  margin: 0 auto;
  padding: 20px;
}

.timelineBox {
  position: relative;

  .timeline {
    width: 100%;
    height: 2px;
    background-color: #34475f;
    position: relative;
    padding: 0 15px 0 10px;
    display: flex;
    justify-content: space-around;
    align-items: center;
    z-index: 10;

    &::after {
      width: 0;
      height: 0;
      border-color: transparent transparent #33455c #33455c;
      border-style: solid;
      border-width: 5px 10px;
      position: absolute;
      right: 1px;
      bottom: 2px;
    }
  }

  .list {
    width: 110px;
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;

    .listItem {
      width: 100%;
      line-height: 1.5;
      border-radius: 4px;
      background-color: rgba(0, 28, 96, 0.5);
      border: 1px solid #476b8f;
      color: #ffffff;
      font-size: 14px;
      text-align: center;
      padding: 0 5px;
    }

    &:before {
      width: 1px;
      height: 44px;
      background-color: #33455c;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .timePoint {
    width: 12px;
    height: auto;
    position: relative;

    .point {
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background-color: #ff0000;
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
    }

    &.special {
      .point {
        width: 12px;
        height: 12px;
        background-color: #ff4f12;
      }
    }

    .yearlabel {
      position: absolute;
      color: #0c0c0c;
      font-size: 16px;
      top: 15px;
      left: 50%;
      transform: translateX(-50%);
    }

    &:nth-child(2n) {
      .yearlabel {
        top: -33px;
      }
    }
  }

  .timeline-up,
  .timeline-down {
    padding: 0 15px 0 10px;
    display: flex;
    justify-content: space-around;

    .timePoint {
      display: flex;
      justify-content: center;

      .listItem {
        width: 110px;
        max-width: 180px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }
  }

  .timeline-up {
    padding-bottom: 44px;

    .list {
      flex-direction: column-reverse;

      .listItem {
        margin-top: 8px;
      }

      &:before {
        bottom: -44px;
      }
    }
  }

  .timeline-down {
    padding-top: 44px;

    .list {
      .listItem {
        margin-bottom: 8px;
      }

      &:before {
        top: -44px;
        z-index: 0;
      }
    }
  }
}
</style>
